import * as LucideIcons from 'lucide-react';

export const DOC_ICONS = {
  'file-text': LucideIcons.FileText,
  'file-code': LucideIcons.FileCode,
  'file': LucideIcons.File,
  'folder': LucideIcons.Folder,
  'book': LucideIcons.Book,
  'book-open': LucideIcons.BookOpen,
  'code': LucideIcons.Code,
  'code-2': LucideIcons.Code2,
  'terminal': LucideIcons.Terminal,
  'bug': LucideIcons.Bug,
  'git-branch': LucideIcons.GitBranch,
  'database': LucideIcons.Database,
  'server': LucideIcons.Server,
  'cloud': LucideIcons.Cloud,
  'api': LucideIcons.Webhook,
  'rocket': LucideIcons.Rocket,
  'zap': LucideIcons.Zap,
  'sparkles': LucideIcons.Sparkles,
  'play': LucideIcons.Play,
  'settings': LucideIcons.Settings,
  'wrench': LucideIcons.Wrench,
  'hammer': LucideIcons.Hammer,
  'puzzle': LucideIcons.Puzzle,
  'puzzle-piece': LucideIcons.Puzzle,
  'blocks': LucideIcons.Blocks,
  'layers': LucideIcons.Layers,
  'box': LucideIcons.Box,
  'package': LucideIcons.Package,
  'download': LucideIcons.Download,
  'upload': LucideIcons.Upload,
  'brain': LucideIcons.Brain,
  'lightbulb': LucideIcons.Lightbulb,
  'robot': LucideIcons.Bot,
  'layout': LucideIcons.Layout,
  'table': LucideIcons.Table,
  'component': LucideIcons.Component,
  'palette': LucideIcons.Palette,
  'image': LucideIcons.Image,
  'message': LucideIcons.MessageSquare,
  'mail': LucideIcons.Mail,
  'bell': LucideIcons.Bell,
  'send': LucideIcons.Send,
  'check': LucideIcons.Check,
  'check-circle': LucideIcons.CheckCircle,
  'x-circle': LucideIcons.XCircle,
  'alert-circle': LucideIcons.AlertCircle,
  'alert-triangle': LucideIcons.AlertTriangle,
  'info': LucideIcons.Info,
  'help-circle': LucideIcons.HelpCircle,
  'lock': LucideIcons.Lock,
  'key': LucideIcons.Key,
  'shield': LucideIcons.Shield,
  'eye': LucideIcons.Eye,
  'user': LucideIcons.User,
  'users': LucideIcons.Users,
  'chart': LucideIcons.BarChart3,
  'trending-up': LucideIcons.TrendingUp,
  'activity': LucideIcons.Activity,
  'star': LucideIcons.Star,
  'heart': LucideIcons.Heart,
  'bookmark': LucideIcons.Bookmark,
  'tag': LucideIcons.Tag,
  'link': LucideIcons.Link,
  'external-link': LucideIcons.ExternalLink,
  'globe': LucideIcons.Globe,
  'home': LucideIcons.Home,
  'calendar': LucideIcons.Calendar,
  'clock': LucideIcons.Clock,
  'arrow-right': LucideIcons.ArrowRight,
  'arrow-left': LucideIcons.ArrowLeft,
  'chevron-right': LucideIcons.ChevronRight,
  'chevron-down': LucideIcons.ChevronDown,
  'list': LucideIcons.List,
  'stairs': LucideIcons.TrendingUp,
  'wand-magic-sparkles': LucideIcons.Wand2,
  'hand': LucideIcons.Hand,
  'mic': LucideIcons.Mic,
  'github': LucideIcons.Github,
  'history': LucideIcons.History,
  'grid': LucideIcons.Grid3x3,
  'credit-card': LucideIcons.CreditCard,
  'indian-rupee': LucideIcons.IndianRupee,
  'link-2': LucideIcons.Link2,
  'message-circle': LucideIcons.MessageCircle,
  'slack': LucideIcons.Slack,
  'smartphone': LucideIcons.Smartphone,
  'type': LucideIcons.Type,
  'shield-check': LucideIcons.ShieldCheck,
};

export const getIcon = (iconName) => {
  if (!iconName) return LucideIcons.FileText;
  // Try DOC_ICONS map first (fast path)
  if (DOC_ICONS[iconName]) return DOC_ICONS[iconName];
  const lowerName = iconName.toLowerCase();
  if (DOC_ICONS[lowerName]) return DOC_ICONS[lowerName];
  const kebabName = iconName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  if (DOC_ICONS[kebabName]) return DOC_ICONS[kebabName];
  // Fallback: resolve any Lucide icon by converting kebab-case to PascalCase
  const pascal = iconName.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('');
  if (LucideIcons[pascal]) return LucideIcons[pascal];
  return LucideIcons.FileText;
};
